import React, { useState, useEffect } from 'react';

import { TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { utils } from 'react-modern-calendar-datepicker';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import api from 'api';
import GeneralInfo from 'containers/Dashboard/General';
import DashboardHeader from 'containers/Dashboard/Header';
import Routes from 'containers/Dashboard/Routes';
import Page from 'containers/Page';
import { AccessTypes, MethodTypes } from 'enums/types';
import { policy } from 'polices';
import { formatDatePicker } from 'utils/parsers';

export default function Dashboard() {
  const policies = policy('dashboard');
  const { push } = useHistory();
  const [range, setRange] = useState({
    from: utils('en').getToday(),
    to: utils('en').getToday(),
  });

  useEffect(() => {
    if (policies(MethodTypes.View) !== AccessTypes.Allow) {
      push('/403');
    }
  }, []);

  const { data, isLoading } = useQuery(['dashboard', range], () => api().get('/dashboard', {
    params: {
      from: formatDatePicker(range.from),
      to: formatDatePicker(range.to),
    },
  }), {
    cacheTime: 0,
    refetchInterval: 10000,
    enabled: !!range.to && !!range.from,
  });

  return (
    <Page
      isLoading={isLoading}
      isCentered>
      <Tabs
        variant="line">
        <DashboardHeader
          range={range}
          setRange={setRange}
        />
        <TabPanels>
          <TabPanel>
            <GeneralInfo data={data?.data} />
          </TabPanel>
          <TabPanel>
            <Routes range={range} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Page>
  );
}
